/* Icon Drinks – Theme-Script
   Sheets & Modals · In die Tasche · Schnellkauf · Beispielprodukte · Merkliste · Mehr laden · Filter · Footer · Cookies */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var HOVER = window.matchMedia('(hover: hover)');
  var S = window.IconDrinksSettings || {};
  var lastTrigger = null;
  window.IconDrinks = window.IconDrinks || {};

  function t(key, fallback) { return (S[key] != null && S[key] !== '') ? S[key] : fallback; }

  /* ---------------- Toast ---------------- */
  function toast(msg, link) {
    var el = document.querySelector('.id-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'id-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    if (link && link.href) {
      var a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.label;
      el.appendChild(a);
    }
    el.classList.add('is-visible');
    clearTimeout(el._h);
    el._h = setTimeout(function () { el.classList.remove('is-visible'); }, 4200);
  }
  window.IconDrinks.toast = toast;

  /* ---------------- Sheets & Modals ---------------- */
  function backdrop() {
    var b = document.querySelector('.id-backdrop');
    if (!b) {
      b = document.createElement('div');
      b.className = 'id-backdrop';
      b.addEventListener('click', closeAll);
      document.body.appendChild(b);
    }
    return b;
  }
  function openSheet(el, trigger) {
    if (!el) return;
    closeAll(true);
    lastTrigger = trigger || document.activeElement;
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    backdrop().classList.add('is-open');
    document.body.classList.add('id-lock');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var f = el.querySelector('[data-id-autofocus]') || el.querySelector('button, a[href], input:not([type="hidden"]), select, textarea');
    if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }, 80);
  }
  function closeAll(silent) {
    var had = false;
    document.querySelectorAll('.id-sheet.is-open, .id-menu.is-open').forEach(function (el) {
      had = true;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[aria-expanded="true"][data-id-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var b = document.querySelector('.id-backdrop');
    if (b) b.classList.remove('is-open');
    document.body.classList.remove('id-lock');
    if (had && silent !== true && lastTrigger && document.contains(lastTrigger)) { try { lastTrigger.focus({ preventScroll: true }); } catch (e) {} }
    if (silent !== true) lastTrigger = null;
  }
  window.IconDrinks.openSheet = openSheet;
  window.IconDrinks.closeSheets = closeAll;

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-id-open]');
    if (o) {
      e.preventDefault();
      openSheet(document.getElementById(o.getAttribute('data-id-open')), o);
      return;
    }
    if (e.target.closest('[data-id-close]')) { e.preventDefault(); closeAll(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAll();
      document.querySelectorAll('.id-card.is-picking').forEach(function (c) { c.classList.remove('is-picking'); });
    }
    if (e.key === 'Tab') {
      var open = document.querySelector('.id-sheet.is-open, .id-menu.is-open');
      if (!open) return;
      var f = Array.prototype.filter.call(open.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea'), function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------------- In die Tasche ---------------- */
  function sectionsFor() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-icon-bubble'];
  }
  function addToCart(variantId, qty, btn) {
    if (!variantId || variantId === 'demo') {
      closeAll(true);
      document.querySelectorAll('.id-card.is-picking').forEach(function (c) { c.classList.remove('is-picking'); });
      toast(t('demoToast', 'Das ist ein Beispielprodukt.'));
      return Promise.resolve(null);
    }
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }], sections: sectionsFor(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Fehler');
        closeAll(true);
        document.querySelectorAll('.id-card.is-picking').forEach(function (c) { c.classList.remove('is-picking'); });
        var drawer = document.querySelector('cart-drawer');
        var item = data.items ? data.items[0] : data;
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: item.variant_id || variantId, sections: data.sections || {} });
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'id-quick-add', productVariantId: variantId, cartData: data });
        }
        return data;
      })
      .catch(function (err) {
        toast(err.message || 'Das hat nicht geklappt. Bitte versuch es nochmal.');
      })
      .finally(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      });
  }
  window.IconDrinks.addToCart = addToCart;

  /* ---------------- Schnellkauf ---------------- */
  function openQuick(card, trigger) {
    var sheet = document.getElementById('id-quickadd');
    var data = card && card.querySelector('[data-id-card-json]');
    if (!sheet || !data) return;
    var p;
    try { p = JSON.parse(data.textContent); } catch (e) { return; }
    var img = sheet.querySelector('[data-q-img]');
    img.src = p.image || '';
    img.alt = p.title || '';
    sheet.querySelector('[data-q-title]').textContent = p.title || '';
    var price = card.querySelector('.id-price');
    sheet.querySelector('[data-q-price]').innerHTML = price ? price.innerHTML : '';
    var pills = sheet.querySelector('[data-q-pills]');
    var label = sheet.querySelector('[data-q-size]');
    var add = sheet.querySelector('[data-q-add]');
    pills.innerHTML = '';
    label.textContent = '–';
    add.disabled = true;
    add.dataset.variant = '';
    (p.options || []).forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'id-pill' + (o.available ? '' : ' is-disabled');
      b.textContent = o.label;
      b.disabled = !o.available;
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () {
        pills.querySelectorAll('.id-pill').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-active');
        b.setAttribute('aria-pressed', 'true');
        label.textContent = o.label;
        add.disabled = false;
        add.dataset.variant = o.id;
      });
      pills.appendChild(b);
    });
    openSheet(sheet, trigger);
  }
  window.IconDrinks.openQuickFor = openQuick;

  document.addEventListener('click', function (e) {
    var bag = e.target.closest('.id-card__bag');
    if (bag) {
      e.preventDefault();
      var card = bag.closest('.id-card');
      if (bag.dataset.variant) { addToCart(bag.dataset.variant, 1, bag); return; }
      if (DESKTOP.matches && HOVER.matches && card.querySelector('.id-card__sizes')) {
        var was = card.classList.contains('is-picking');
        document.querySelectorAll('.id-card.is-picking').forEach(function (c) { c.classList.remove('is-picking'); });
        if (!was) {
          card.classList.add('is-picking');
          var first = card.querySelector('.id-card__sizes .id-pill:not([disabled])');
          if (first) first.focus({ preventScroll: true });
        }
      } else {
        openQuick(card, bag);
      }
      return;
    }
    var pill = e.target.closest('.id-card__sizes .id-pill');
    if (pill) { e.preventDefault(); addToCart(pill.dataset.variant, 1, pill); return; }
    var qa = e.target.closest('[data-q-add]');
    if (qa && qa.dataset.variant) { e.preventDefault(); addToCart(qa.dataset.variant, 1, qa); return; }
    var pick = e.target.closest('[data-idp-pick]');
    if (pick) { e.preventDefault(); openQuick(pick.closest('.id-card, [data-id-card]'), pick); return; }
    var quick = e.target.closest('[data-idp-quick]');
    if (quick) { e.preventDefault(); addToCart(quick.dataset.idpQuick, 1, quick); return; }
    if (!e.target.closest('.id-card')) {
      document.querySelectorAll('.id-card.is-picking').forEach(function (c) { c.classList.remove('is-picking'); });
    }
  });

  /* ---------------- Merkliste (im Browser gespeichert) ---------------- */
  var WKEY = 'icondrinks-wishlist';
  var DKEY = 'icondrinks-wishlist-dates';
  function wishDates() {
    try { var v = JSON.parse(localStorage.getItem(DKEY) || '{}'); return (v && typeof v === 'object') ? v : {}; } catch (e) { return {}; }
  }
  function wishDate(h, on) {
    var d = wishDates();
    if (on) d[h] = new Date().toISOString(); else delete d[h];
    try { localStorage.setItem(DKEY, JSON.stringify(d)); } catch (e) {}
  }
  function wishRead() {
    try { var v = JSON.parse(localStorage.getItem(WKEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function wishWrite(list) {
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('id:wishlist', { detail: { list: list } }));
  }
  function wishSync() {
    var list = wishRead();
    document.querySelectorAll('[data-id-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-id-wish')) !== -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = on ? b.getAttribute('data-label-on') : b.getAttribute('data-label-off');
      if (l) b.setAttribute('aria-label', l);
    });
    document.querySelectorAll('[data-id-wish-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
  }
  window.IconDrinks.wishlist = { read: wishRead, write: wishWrite, sync: wishSync, dates: wishDates, setDate: wishDate };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-id-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-id-wish');
    var list = wishRead();
    var i = list.indexOf(h);
    if (i === -1) {
      list.unshift(h);
      wishDate(h, true);
      toast(t('wishAdded', 'Auf deiner Merkliste gespeichert.'), (S.wishUrl && window.location.pathname !== S.wishUrl) ? { href: S.wishUrl, label: t('wishLink', 'Ansehen') } : null);
    } else {
      list.splice(i, 1);
      wishDate(h, false);
      toast(t('wishRemoved', 'Von deiner Merkliste entfernt.'));
    }
    wishWrite(list.slice(0, 60));
    wishSync();
  });

  /* ---------------- Mehr laden (Kollektion/Suche) ---------------- */
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-id-more]');
    if (!more) return;
    e.preventDefault();
    var url = more.getAttribute('href');
    var sel = more.getAttribute('data-id-more');
    var grid = document.querySelector(sel);
    if (!url || !grid) return;
    more.classList.add('is-loading');
    more.setAttribute('aria-busy', 'true');
    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector(sel);
        if (nextGrid) Array.prototype.forEach.call(nextGrid.children, function (c) { grid.appendChild(document.importNode(c, true)); });
        var nextMore = doc.querySelector('[data-id-more]');
        var count = document.querySelector('[data-id-loaded]');
        var nextCount = doc.querySelector('[data-id-loaded]');
        if (count && nextCount) count.textContent = nextCount.textContent;
        if (nextMore) more.setAttribute('href', nextMore.getAttribute('href'));
        else more.remove();
        if (window.history && window.history.replaceState) window.history.replaceState({}, '', url);
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { more.classList.remove('is-loading'); more.removeAttribute('aria-busy'); });
  });

  /* ---------------- Filter: Desktop sofort anwenden ---------------- */
  document.addEventListener('change', function (e) {
    var form = e.target.closest('form[data-id-autosubmit]');
    if (form && DESKTOP.matches) {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
    }
  });

  /* ---------------- Footer: Akkordeons nur mobil ---------------- */
  function syncFooter() {
    document.querySelectorAll('[data-id-footer-acc]').forEach(function (d) {
      if (DESKTOP.matches) d.setAttribute('open', '');
      else if (!d.dataset.touched) d.removeAttribute('open');
    });
  }
  document.addEventListener('toggle', function (e) {
    if (e.target.matches && e.target.matches('[data-id-footer-acc]') && !DESKTOP.matches) e.target.dataset.touched = '1';
  }, true);
  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', syncFooter);

  /* ---------------- Cookie-Einstellungen ---------------- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-id-cookies]');
    if (!c) return;
    e.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    } else {
      toast(t('cookieHint', 'Die Cookie-Einstellungen sind gerade nicht verfügbar.'));
    }
  });

  function ready() { syncFooter(); wishSync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', ready);
})();
